import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './index.scss';

import { APP_LAYOUT } from '../../data/config/constants';
import { isModuleAccessible } from '../../data/config/utils';
import { IconMenuBar, IconRight } from '../../data/assets/icons';

class PageNavbar extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            show_menu_item: false,
        };
    }

    handleMenuItemView = () => {
        this.setState((prevState) => ({
            show_menu_item: !prevState.show_menu_item
        }));
    };

    render() {
        const { item_center, bordered, column, column_width, page_details, admin_details, bg_white, box_shadow, menu, navigateTo, title } = this.props;
        const { show_menu_item } = this.state;
        const mobile = page_details.device_data.screen_width < 768;
        const permissions = admin_details.user_info && admin_details.user_info.permissions ? admin_details.user_info.permissions : null

        return (
            <div className={classNames("ori-relative oriPageNavbarContainer", { "ori-flex-row": !column, "ori-flex-jc": item_center && !mobile && !column, "ori-b-border-default": (bordered && !column || mobile), "ori-r-border-default": bordered && column && !mobile, "ori-overflow-auto": column && !mobile, "ori-bg-white": bg_white && !mobile, "ori-box-shadow-light": box_shadow && !mobile })} style={{ height: column && !mobile ? `${page_details.device_data.screen_height - APP_LAYOUT.APP_HEADER_HEIGHT}px` : `${APP_LAYOUT.PAGE_NAVBAR_HEIGHT}px`, width: column && !mobile ? `${column_width}px` : `100%` }}>
                {
                    !mobile &&
                    <div className={classNames("ori-flex-none", { "ori-full-parent-height ori-flex-row": !column, "ori-flex-column ori-full-width": column })} style={{ lineHeight: !column ? `${APP_LAYOUT.PAGE_NAVBAR_HEIGHT}px` : "", }}>
                        {
                            menu && menu.children && menu.children.map((item, index) => {
                                const is_allowed = isModuleAccessible(permissions, item.route_path, menu.route_path);
                                if (is_allowed) {
                                    return (
                                        <div key={index} className={classNames("ori-capitalize-first ori-font-light-hover-primary ", { "ori-lr-pad-15 ori-tb-pad-10 ori-full-width ori-text-overflow-dotted navbarItemColumn": column, "ori-lr-pad-5 ori-lr-mrgn-5 navbarItemRow": !column, "activeItemColumn ori-bg-default": (page_details.current_page === item.app_page) && column, "activeItemRow": (page_details.current_page === item.app_page) && !column })} onClick={() => navigateTo(item.route_path)}>
                                            <span>{item.app_page}</span>
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            })
                        }
                    </div>
                }
                {
                    mobile &&
                    <div className="ori-absolute ori-align-left-10 ori-cursor-ptr" style={{ lineHeight: `${APP_LAYOUT.PAGE_NAVBAR_HEIGHT}px` }} onClick={this.handleMenuItemView}>
                        <IconMenuBar size={24} />
                        <span className="ori-capitalize ori-lr-pad-10 ori-font-15">{title}</span>
                    </div>
                }
                {
                    show_menu_item && mobile &&
                    <div className=" ori-overflow-hidden ori-absolute ori-align-left ori-align-right ori-align-top-full ori-b-pad-5 ori-zindex-150">
                        <div className="ori-animated ori-translate-down ori-bg-white ori-box-shadow-light">
                            {
                                menu && menu.children && menu.children.map((item, index) => {
                                    const is_allowed = isModuleAccessible(permissions, item.route_path, menu.route_path);
                                    if (is_allowed) {
                                        return (
                                            <div key={index} className={classNames("ori-lr-pad-10  ori-font-light-hover-primary ori-flex-row ori-flex-jsb", { "ori-font-primary ori-text-overflow-dotted ori-font-bold ": page_details.current_page === item.app_page })} style={{ height: '37px', lineHeight: '37px' }} onClick={() => { navigateTo(item.route_path); setTimeout(this.handleMenuItemView, 800) }}>
                                                <span className="ori-capitalize-first">{item.app_page}</span>
                                                <div>
                                                    <IconRight size={18} />
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return null;
                                    }
                                })
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}

PageNavbar.propTypes = {
    title: PropTypes.string,
    item_center: PropTypes.bool,
    box_shadow: PropTypes.bool,
    bordered: PropTypes.bool,
    page_details: PropTypes.object.isRequired,
    admin_details: PropTypes.object.isRequired,
    menu: PropTypes.object,
    navigateTo: PropTypes.func,
    column: PropTypes.bool,
    column_width: PropTypes.number,
    bg_white: PropTypes.bool
};

PageNavbar.defaultProps = {
    title: "title",
    item_center: false,
    border_bottom: false,
    bordered: false,
    column: false,
    column_width: 180,
    bg_white: false,
    box_shadow: false,
};

export default PageNavbar;


// WEBPACK FOOTER //
// ./src/components/pagenavbar/index.js